import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { ProductPage } from './pages/ProductPage';
export function App() {
  return <ProductPage data-id="element-0" />;
}